import React from 'react';

const Banner = () => {
  return (
    <section className="banner">
      <div className="banner-inner">
        <h2>Ready to Watch Live Fights & Sports?</h2>
        <p>Click through to our streaming partners to see live and on-demand boxing, MMA, international soccer nights and more. Plan details and availability vary by country – always check on the official page.</p>
        <a className="cta-primary" href="https://www.awin1.com/cread.php?awinmid=126253&awinaffid=2941253&ued=https%3A%2F%2Fwww.dazn.com%2Fen-US%2Fwelcome
 ">Go to Streaming Partner</a>
      </div>
    </section> 
  );
};

export default Banner;    
